// extracted by mini-css-extract-plugin
module.exports = {"selectShort":"Copier_selectShort__o0QBB","form":"Copier_form__zDeWs","selectLong":"Copier_selectLong___xHt-","select":"Copier_select__27lJs"};